import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Checkbox',
    props: {
        id: { type: String, required: false },
        name: { type: String, required: false },
        checkboxClass: { type: String, required: false, default: "" },
        checked: { type: Boolean, required: false, default: false },
        value: { type: [String, Number], required: false },
        modelValue: { type: [Boolean, String, Number, Array], required: false },
        disabled: { type: Boolean, required: false, default: false }
    },
    emits: ["update:modelValue", "change", "click"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emit = __emit;
        const isChecked = computed(() => {
            if (Array.isArray(props.modelValue)) {
                return props.modelValue.includes(props.value);
            }
            return props.checked || props.modelValue === props.value;
        });
        const handleChange = (event) => {
            const target = event.target;
            if (Array.isArray(props.modelValue)) {
                const newValue = [...props.modelValue];
                if (target.checked) {
                    if (!newValue.includes(props.value)) {
                        newValue.push(props.value);
                    }
                }
                else {
                    const index = newValue.indexOf(props.value);
                    if (index > -1) {
                        newValue.splice(index, 1);
                    }
                }
                emit("update:modelValue", newValue);
            }
            else {
                emit("update:modelValue", target.checked ? props.value : false);
            }
            emit("change", event);
        };
        const handleLabelClick = (event) => {
            event.stopPropagation();
            emit("click", event);
        };
        const handleInputClick = (event) => {
            event.stopPropagation();
        };
        const __returned__ = { props, emit, isChecked, handleChange, handleLabelClick, handleInputClick };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
